
import { createAction, props } from '@ngrx/store';
import { UploadActionProps } from '../../guards/resolver.helper';
import { GatewayResponseErrorType } from '../../services/app-gateway.service';
import { TextTemplateTagAddRequest, TextTemplateTagDeleteRequest, TextTemplateTagEditRequest } from '@dave/types';
import { TextTemplateTagEntity } from '../../entities/text-template-tag.entity';





const prefix = 'data/' + 'textTemplateTag/';
export const TextTemplateTagActionTypes = {
    Load: createAction(prefix + 'load', props< UploadActionProps >()),
    Change: createAction(prefix + 'change', props<{ Payload: TextTemplateTagEditRequest }>()),
    Delete: createAction(prefix + 'delete', props<{ Payload: TextTemplateTagDeleteRequest }>()),


    UpdateAll: createAction(prefix + 'updateAll', props<{ Payload: Array<TextTemplateTagEntity>; updateLatestUpdatedAt?: boolean }>()),
    UpdateMany: createAction(prefix + 'updateMany', props<{ Payload: Array<TextTemplateTagEntity>; updateLatestUpdatedAt?: boolean }>()),
    UpdateOne: createAction(prefix + 'updateOne', props<{ Payload: TextTemplateTagEntity }>()),
    RemoveOne: createAction(prefix + 'remove', props<{ Payload: number }>()),

    CreateRequest: createAction(prefix + 'create/request', props<{ Payload: TextTemplateTagAddRequest }>()),
    CreateSuccess: createAction(prefix + 'create/success', props<{ Payload: TextTemplateTagEntity }>()),
    CreateFailure: createAction(prefix + 'create/failure', props<{ Payload: { Errors: GatewayResponseErrorType; ToasterMessage?: string } }>()),
};
